import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../../Enums/Size.enum';
import ManagerInsuranceCompaniesBatchCreateTable from './ManagerInsuranceCompaniesBatchCreateTable';
import { InsuranceCompanyBatch } from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';

interface Props extends BaseModalProps {
	batches: InsuranceCompanyBatch[];
}

const ManagerInsuranceCompaniesBatchCreateTableModal = ({
	batches,
	...modalProps
}: Props) => {
	return (
		<BaseModal
			{...modalProps}
			title={'component.insuranceCompanyBatch.createForm.successMessage'}
			size={Size.XL}>
			<ManagerInsuranceCompaniesBatchCreateTable batches={batches} />
		</BaseModal>
	);
};

export default ManagerInsuranceCompaniesBatchCreateTableModal;
